import { get } from "lodash";

import { AppConfigs } from "../models/AppConfigs";
import { AppEnvironmentConfig } from "./AppConfigs";

/* Config from config.json - START */
export const updateConfigs = (data: AppConfigs) => {
  configs = data;
  configUrl = data.REACT_APP_PORTAL_HOST_CONFIG;
  reactAppDebug = data.REACT_APP_PORTAL_DEBUG === 1;
  loginUrl = data.REACT_APP_PORTAL_LOGINURL;
  clientId = data.REACT_APP_PORTAL_CLIENT;
  knownAuthorities = data.REACT_APP_PORTAL_KNOWN_AUTHORIETIES;
  redirectUri = data.REACT_APP_PORTAL_REDIRECT_URI;
  b2cScope = data.REACT_APP_PORTAL_B2C_SCOPE;
  googleMapKey = data.REACT_APP_PORTAL_GOOGLE_MAP_KEY;
  maxFileSize = data.REACT_APP_PORTAL_MAX_FILE_SIZE;
  oasisUpload = data.REACT_APP_PORTAL_OASIS_UPLOAD;
  nomnc = data.REACT_APP_PORTAL_NOMNC;
  providerFinder = data.REACT_APP_PORTAL_PROVIDER_FINDER;
  priorAuthorizationRequest = data.REACT_APP_PORTAL_PRIOR_AUTHORIZATION_REQUEST;
  referralFormNevadaOnly = data.REACT_APP_PORTAL_REFERRAL_FORM_NEVADA_ONLY;
  centeneAmbetterPaPaRequestForm =
    data.REACT_APP_PORTAL_CENTENE_AMBETTER_PA_PA_REQUEST_FORM;
  resumptionOfCareRequestForm = data.REACT_APP_PORTAL_RESUMPTION_OF_CARE_REQUEST_FORM;
  reAuthorizationRequestForm = data.REACT_APP_PORTAL_RE_AUTHORIZATION_REQUEST_FORM;
  startOfCareConfirmationForm = data.REACT_APP_PORTAL_START_OF_CARE_CONFIRMATION_FORM;
  faxConfirmationForm = data.REACT_APP_PORTAL_FAX_CONFIRMATION_FORM;
  outOfNetworkServiceNotification =
    data.REACT_APP_PORTAL_OUT_OF_NETWORK_SERVICE_NOTIFICATION;
  electronicsFundsTransferEnrollment =
    data.REACT_APP_PORTAL_ELECTRONICS_FUNDS_TRANSFER_ENROLLMENT;
  claimsDispute = data.REACT_APP_PORTAL_CLAIMS_DISPUTE;
  informationChangeForm = data.REACT_APP_PORTAL_INFORMATION_CHANGE_FORM;
  providerManual = data.REACT_APP_PORTAL_PROVIDER_MANUAL;
  maxServiceProviderCount = data.REACT_APP_PORTAL_MAX_SERVICE_PROVIDER_COUNT;
  managedHealthPlanList = data.REACT_APP_PORTAL_MANAGED_HEALTH_PLAN_LIST;
  freshchatUrl = data.REACT_APP_PORTAL_FRESHCHAT_URL;
  freshchatWidget = data.REACT_APP_PORTAL_FRESHCHAT_WIDGET;
  documentMaxFileSize = data.REACT_APP_PORTAL_DOCUMENT_MAX_FILE_SIZE;
  tangoCareUploadUrl = data.REACT_APP_PORTAL_TANGO_CARE_UPLOAD_URL;
  ssoHpsUrl = data.REACT_APP_PORTAL_SSO_HPS_URL;
  hpsClaimsStatusFormUrl = data.REACT_APP_PORTAL_HPS_CLAIMS_STATUS_FORM_URL;
};

export let configs: AppConfigs = {
  REACT_APP_PORTAL_HOST_CONFIG: "",
  REACT_APP_PORTAL_CLIENT: "",
  REACT_APP_PORTAL_LOGINURL: "",
  REACT_APP_PORTAL_KNOWN_AUTHORIETIES: "",
  REACT_APP_PORTAL_REDIRECT_URI: "",
  REACT_APP_PORTAL_DEBUG: false,
  REACT_APP_PORTAL_B2C_SCOPE: "",
  REACT_APP_PORTAL_GOOGLE_MAP_KEY: "",
  REACT_APP_PORTAL_MAX_FILE_SIZE: 0,
  REACT_APP_PORTAL_OASIS_UPLOAD: "",
  REACT_APP_PORTAL_NOMNC: "",
  REACT_APP_PORTAL_PROVIDER_FINDER: "",
  REACT_APP_PORTAL_PRIOR_AUTHORIZATION_REQUEST: "",
  REACT_APP_PORTAL_REFERRAL_FORM_NEVADA_ONLY: "",
  REACT_APP_PORTAL_CENTENE_AMBETTER_PA_PA_REQUEST_FORM: "",
  REACT_APP_PORTAL_RESUMPTION_OF_CARE_REQUEST_FORM: "",
  REACT_APP_PORTAL_RE_AUTHORIZATION_REQUEST_FORM: "",
  REACT_APP_PORTAL_START_OF_CARE_CONFIRMATION_FORM: "",
  REACT_APP_PORTAL_FAX_CONFIRMATION_FORM: "",
  REACT_APP_PORTAL_OUT_OF_NETWORK_SERVICE_NOTIFICATION: "",
  REACT_APP_PORTAL_ELECTRONICS_FUNDS_TRANSFER_ENROLLMENT: "",
  REACT_APP_PORTAL_CLAIMS_DISPUTE: "",
  REACT_APP_PORTAL_INFORMATION_CHANGE_FORM: "",
  REACT_APP_PORTAL_PROVIDER_MANUAL: "",
  REACT_APP_PORTAL_MAX_SERVICE_PROVIDER_COUNT: 0,
  REACT_APP_PORTAL_MANAGED_HEALTH_PLAN_LIST: "",
  REACT_APP_PORTAL_FRESHCHAT_URL : "",
  REACT_APP_PORTAL_FRESHCHAT_WIDGET : "",
  REACT_APP_PORTAL_DOCUMENT_MAX_FILE_SIZE : "",
  REACT_APP_PORTAL_TANGO_CARE_UPLOAD_URL: "",
  REACT_APP_PORTAL_SSO_HPS_URL: "",
  REACT_APP_PORTAL_HPS_CLAIMS_STATUS_FORM_URL: "",
  REACT_APP_PORTAL_REPLACE_START: "",
  REACT_APP_PORTAL_REPLACE_END: "",
  REACT_APP_PORTAL_SAML_CALLBACK: ""
};

export const updateVariables = (variables: any) => {
  const {
    REACT_APP_PORTAL_HOST_CONFIG,
    REACT_APP_PORTAL_CLIENT,
    REACT_APP_PORTAL_LOGINURL,
    REACT_APP_PORTAL_KNOWN_AUTHORIETIES,
    REACT_APP_PORTAL_REDIRECT_URI,
    REACT_APP_PORTAL_B2C_SCOPE,
    REACT_APP_PORTAL_GOOGLE_MAP_KEY,
    REACT_APP_PORTAL_SAML_CALLBACK
  } = variables;

  configUrl = REACT_APP_PORTAL_HOST_CONFIG;
  clientId = REACT_APP_PORTAL_CLIENT;
  loginUrl = REACT_APP_PORTAL_LOGINURL;
  knownAuthorities = REACT_APP_PORTAL_KNOWN_AUTHORIETIES;
  redirectUri = REACT_APP_PORTAL_REDIRECT_URI;
  b2cScope = REACT_APP_PORTAL_B2C_SCOPE;
  googleMapKey = REACT_APP_PORTAL_GOOGLE_MAP_KEY;
  samlCallback = REACT_APP_PORTAL_SAML_CALLBACK;


  Object.assign(configs, {
    REACT_APP_PORTAL_HOST_CONFIG,
    REACT_APP_PORTAL_CLIENT,
    REACT_APP_PORTAL_LOGINURL,
    REACT_APP_PORTAL_KNOWN_AUTHORIETIES,
    REACT_APP_PORTAL_REDIRECT_URI,
    REACT_APP_PORTAL_B2C_SCOPE,
    REACT_APP_PORTAL_GOOGLE_MAP_KEY,
    REACT_APP_PORTAL_SAML_CALLBACK
  });

}

export let configUrl = configs.REACT_APP_PORTAL_HOST_CONFIG;
export let reactAppDebug = configs.REACT_APP_PORTAL_DEBUG;
export let clientId = configs.REACT_APP_PORTAL_CLIENT;
export let loginUrl = configs.REACT_APP_PORTAL_LOGINURL;
export let knownAuthorities = configs.REACT_APP_PORTAL_KNOWN_AUTHORIETIES;
export let redirectUri = configs.REACT_APP_PORTAL_REDIRECT_URI;
export let b2cScope = configs.REACT_APP_PORTAL_B2C_SCOPE;
export let googleMapKey = configs.REACT_APP_PORTAL_GOOGLE_MAP_KEY;
export let maxFileSize = configs.REACT_APP_PORTAL_MAX_FILE_SIZE;
export let oasisUpload = configs.REACT_APP_PORTAL_OASIS_UPLOAD;
export let nomnc = configs.REACT_APP_PORTAL_NOMNC;
export let providerFinder = configs.REACT_APP_PORTAL_PROVIDER_FINDER;
export let priorAuthorizationRequest =
  configs.REACT_APP_PORTAL_PRIOR_AUTHORIZATION_REQUEST;
export let referralFormNevadaOnly =
  configs.REACT_APP_PORTAL_REFERRAL_FORM_NEVADA_ONLY;
export let centeneAmbetterPaPaRequestForm =
  configs.REACT_APP_PORTAL_CENTENE_AMBETTER_PA_PA_REQUEST_FORM;
export let resumptionOfCareRequestForm =
  configs.REACT_APP_PORTAL_RESUMPTION_OF_CARE_REQUEST_FORM;
export let reAuthorizationRequestForm =
  configs.REACT_APP_PORTAL_RE_AUTHORIZATION_REQUEST_FORM;
export let startOfCareConfirmationForm =
  configs.REACT_APP_PORTAL_START_OF_CARE_CONFIRMATION_FORM;
export let faxConfirmationForm =
  configs.REACT_APP_PORTAL_FAX_CONFIRMATION_FORM;
export let outOfNetworkServiceNotification =
  configs.REACT_APP_PORTAL_OUT_OF_NETWORK_SERVICE_NOTIFICATION;
export let electronicsFundsTransferEnrollment =
  configs.REACT_APP_PORTAL_ELECTRONICS_FUNDS_TRANSFER_ENROLLMENT;
export let claimsDispute = configs.REACT_APP_PORTAL_CLAIMS_DISPUTE;
export let informationChangeForm =
  configs.REACT_APP_PORTAL_INFORMATION_CHANGE_FORM;
export let providerManual = configs.REACT_APP_PORTAL_PROVIDER_MANUAL;
export let maxServiceProviderCount = configs.REACT_APP_PORTAL_MAX_SERVICE_PROVIDER_COUNT;
export let managedHealthPlanList = configs.REACT_APP_PORTAL_MANAGED_HEALTH_PLAN_LIST;
export let freshchatUrl = configs.REACT_APP_PORTAL_FRESHCHAT_URL;
export let freshchatWidget = configs.REACT_APP_PORTAL_FRESHCHAT_WIDGET;
export let documentMaxFileSize = configs.REACT_APP_PORTAL_DOCUMENT_MAX_FILE_SIZE;
export let tangoCareUploadUrl = configs.REACT_APP_PORTAL_TANGO_CARE_UPLOAD_URL;
export let ssoHpsUrl = configs.REACT_APP_PORTAL_SSO_HPS_URL;
export let hpsClaimsStatusFormUrl = configs.REACT_APP_PORTAL_HPS_CLAIMS_STATUS_FORM_URL;
export let samlCallback = configs.REACT_APP_PORTAL_SAML_CALLBACK;
/* Config from config.json - END */

/* App level config constants - START */

//Check if running as localhost
export const IS_LOCALHOST: boolean =
  get(process.env, "NODE_ENV", "") === AppEnvironmentConfig.DEV;

//Applied endpoint for localhost -> can be changed via CLI e.g. set REACT_APP_ENDPOINT_ENV=SB
export const REACT_APP_ENDPOINT_ENV = get(
  process.env,
  "REACT_APP_ENDPOINT_ENV",
  ""
);

/* App level config constants - END */
